import React, { useState } from 'react';
import style from './SignUp.module.css';
import { useLogin } from '../../hooks/useLogin';

export default function Login({ loginUser }) {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const { login, error, isLoading } = useLogin();

  const handleSubmit = async (e) => {
    e.preventDefault();
    await login(email, password);
  };

  return (
    <div className={style.wrapper}>
      <form onSubmit={handleSubmit}>
        <div className={style.section}>
        <center><h1>Logowanie</h1></center>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='name-data'>Adres e-mail:</label>
            <input type='text' placeholder='email' onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='password'>Hasło:</label>
            <input type='password' placeholder='hasło' onChange={(e) => setPassword(e.target.value)} />
          </div>
          <p className={style.errorMessage}>{error?.message}</p>
        </div>
        <center>
        <button disabled={isLoading} className='btn btn-default' type='submit'>Zaloguj</button></center>
      </form>
    </div>
  );
}
